export const isBrowser = typeof window !== 'undefined';
export const api_url = process.env.GATSBY_API_URL;
